<div class="dialog-title">
    <h3> {{data.Title}}</h3>
    <span mat-button mat-dialog-close>
        <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
            <path id="close-btn"
                d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                transform="translate(5.82 13.32)" fill="#bbb" />
        </svg>
    </span>
</div>
<mat-dialog-content class="p-0 create_auction" *ngIf="!loadingData && !loadingCategory">
    <mat-stepper [linear]="true" (window:resize)="onWindowResize($event)"  [orientation]="getScreenWidth < 870?'vertical':'horizontal'" #stepper>
        <mat-step [stepControl]="MainInfo_Form">

            <form [formGroup]="MainInfo_Form">
                <ng-template matStepLabel>{{'items-requests.Main Info' | translate}}</ng-template>

                <div class="inputs-form-section">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'Auctions.Title [English]'|translate}}</mat-label>
                        <input formControlName="name_en" matInput maxlength="100">
                        <mat-error *ngIf="hasError(MainInfo_Form,'name_en','required')">
                            {{'Auctions.Field is Required'|translate}}
                        </mat-error>
                        <mat-error *ngIf="hasError(MainInfo_Form,'name_en','pattern')">
                            {{'items-requests.accept only English and special characters' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="inputs-form-section">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'Auctions.Title [Arabic]'|translate}}</mat-label>
                        <input formControlName="name_ar" matInput maxlength="100">
                        <mat-error *ngIf="hasError(MainInfo_Form,'name_ar','required')">
                            {{'Auctions.Field is Required'|translate}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="inputs-form-section">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'Auctions.Description [English]'|translate}}</mat-label>
                        <textarea formControlName="description_en" matInput maxlength="255" rows="6"></textarea>
                        <mat-error *ngIf="hasError(MainInfo_Form,'name_en','pattern')">
                            {{'items-requests.accept only English and special characters' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="inputs-form-section">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'Auctions.Description [Arabic]'|translate}}</mat-label>
                        <textarea formControlName="description_ar" matInput maxlength="255" rows="6"></textarea>
                    </mat-form-field>
                </div>

                <div class="inputs-form-section">
                    <mat-form-field appearance="outline">
                        <mat-label>{{'Auctions.Category'|translate}}</mat-label>
                        <mat-select formControlName="category_id">
                            <mat-option *ngFor="let item of categoriesList" [value]="item.id"
                                (click)="LoadCategoryTemplate(item.id)">
                                {{item.name}}
                            </mat-option>
                        </mat-select>

                        <mat-error *ngIf="hasError(MainInfo_Form,'category_id','required')">
                            {{'Auctions.Field is Required'|translate}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- <div class="title">Bidding Time</div>
  
          <div class="inputs-form-section">
            <mat-form-field appearance="outline">
              <mat-label>{{"Auctions.Date"|translate}}</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="date" [min]="Date_Min_Max.min"
                [max]="Date_Min_Max.max">
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="hasError(MainInfo_Form,'date','required')">
                {{'Auctions.Field is Required'|translate}}
              </mat-error>
              <mat-error
                *ngIf="hasError(MainInfo_Form,'date','matDatepickerMin')||hasError(MainInfo_Form,'date','matDatepickerMax')">
                {{"Auctions.Date Out of Range"|translate}}
              </mat-error>
            </mat-form-field>
          </div>
  
          <div class="SlideToggle">
            <mat-slide-toggle color="primary" id="slideToggle" [(ngModel)]="AuctionItemHaveEndTime"
              [ngModelOptions]="{standalone:true}" [labelPosition]="'before'">
              <mat-label for="slideToggle"> Item have end time? </mat-label>
            </mat-slide-toggle>
            <div class="desc">
              <p>If you choose, an end date will be set for that item.
              </p>
            </div>
            <div class="row mt-3">
              <div class="inputs-form-section"
                [ngClass]="{'col-md-6 col-12': AuctionItemHaveEndTime , 'col-12':!AuctionItemHaveEndTime}">
                <mat-form-field appearance="outline">
                  <mat-label>{{"Auctions.Start Time"|translate}} </mat-label>
                  <input matInput [format]="12" formControlName="start_at" [max]="TimeStartMax"
                    [ngxMatTimepicker]="pickerStart" placeholder="12:00" readonly />
                  <ngx-mat-timepicker-toggle matSuffix (click)="pickerStart.open()"></ngx-mat-timepicker-toggle>
                  <mat-error *ngIf="hasError(MainInfo_Form,'start_at','required')">
                    {{'Auctions.Field is Required'|translate}}
                  </mat-error>
                </mat-form-field>
                <ngx-mat-timepicker color="primary" #pickerStart></ngx-mat-timepicker>
              </div>
              <div class="inputs-form-section col-md-6 col-12" [hidden]="!AuctionItemHaveEndTime">
                <mat-form-field appearance="outline">
                  <mat-label>{{"Auctions.End Time"|translate}} </mat-label>
                  <input matInput [format]="12" formControlName="end_at" [min]="TimeEndMin" [ngxMatTimepicker]="pickerEnd"
                    placeholder="12:00" readonly [required]="AuctionItemHaveEndTime" />
                  <ngx-mat-timepicker-toggle matSuffix (click)="pickerEnd.open()">
                    <mat-icon>access_time</mat-icon>
                  </ngx-mat-timepicker-toggle>
                  <mat-error *ngIf="hasError(MainInfo_Form,'end_at','required')">
                    {{'Auctions.Field is Required'|translate}}
                  </mat-error>
                </mat-form-field>
                <ngx-mat-timepicker color="primary" #pickerEnd></ngx-mat-timepicker>
              </div>
            </div>
  
          </div> -->


                <div class="group_btn justify-content-between">
                    <button mat-button class="btnLight_fill" mat-dialog-close>{{'actions.cancel' | translate}}</button>
                    <!-- <div> </div> -->
                    <button mat-button class="btn_fill" type="submit" matStepperNext>{{'items-requests.Next' |
                        translate}}</button>
                </div>
            </form>
        </mat-step>

        <mat-step [stepControl]="Details_Photos_Form">
            <form [formGroup]="Details_Photos_Form">
                <ng-template matStepLabel>{{'items-requests.Item Details & Photos' | translate}}</ng-template>
                <div class="title">{{'Auction Item.Item Details' | translate}}</div>
                <table class="w-100 table-responsive">
                    <thead>
                        <tr>
                            <th width="5%"></th>
                            <th width="45%">{{'items-requests.Lable' | translate}}</th>
                            <th width="45%">{{'items-requests.Value' | translate}}</th>
                            <th width="5%"></th>
                        </tr>
                    </thead>
                    <tbody formArrayName="details" cdkDropList (cdkDropListDropped)="drop($event)">
                        <tr *ngFor="let item of formDetailsControls.controls; let i=index" [formGroupName]="i" [id]="i"
                            [cdkDragDisabled]="itemSelected==i" (cdkDragDropped)="dropping=false" cdkDrag
                            class="details_item">
                            <td width="5%" class="DragIcon">
                                <img width="20" height="20" cdkDragHandle src="assets/images/icons/DragDropIcon.svg"
                                    alt="">
                            </td>
                            <td width="45%">
                                <div class="inputs-form-section w-100">
                                    <mat-form-field appearance="outline" class="pb-1">
                                        <mat-label>{{
                                            ("Auctions.Key English"|translate)}}
                                        </mat-label>
                                        <input formControlName="key_en" matInput maxlength="50">
                                        <mat-error *ngIf="getValidity(i,'key_en','required')">
                                            {{'Auctions.Field is Required'|translate}}
                                        </mat-error>
                                        <mat-error *ngIf="getValidity(i,'key_en','pattern')">
                                            {{'items-requests.accept only English and special characters' | translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="inputs-form-section w-100">
                                    <mat-form-field appearance="outline" class="pb-1">
                                        <mat-label>{{
                                            ("Auctions.Key Arabic"|translate)}}
                                        </mat-label>
                                        <input formControlName="key_ar" matInput maxlength="50">
                                        <mat-error *ngIf="getValidity(i,'key_ar','required')">
                                            {{'Auctions.Field is Required'|translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                            </td>
                            <td width="45%">
                                <div class="inputs-form-section  w-100">
                                    <mat-form-field appearance="outline" class="pb-1">
                                        <mat-label>
                                            {{
                                            ("Auctions.Value English"|translate)}}
                                        </mat-label>
                                        <input formControlName="value_en" matInput maxlength="50">
                                        <mat-error *ngIf="getValidity(i,'value_en','required')">
                                            {{'Auctions.Field is Required'|translate}}
                                        </mat-error>
                                        <mat-error *ngIf="getValidity(i,'value_en','pattern')">
                                            {{'items-requests.accept only English and special characters' | translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="inputs-form-section  w-100">
                                    <mat-form-field appearance="outline" class="pb-1">
                                        <mat-label>
                                            {{
                                            ("Auctions.Value Arabic"|translate)}}
                                        </mat-label>
                                        <input formControlName="value_ar" matInput maxlength="50">
                                        <mat-error *ngIf="getValidity(i,'value_ar','required')">
                                            {{'Auctions.Field is Required'|translate}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                            </td>
                            <td width="5%" class="colseIcon">
                                <div (click)="removeDeatilsItem(i)" class="rounded-circle" aria-label="Clear" *ngIf="i">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10.604" height="10.604"
                                        viewBox="0 0 10.604 10.604">
                                        <path id="close-ic"
                                            d="M207.3,304.561l-3.776,3.776a.89.89,0,1,1-1.259-1.259l3.776-3.776-3.776-3.776a.89.89,0,1,1,1.259-1.259l3.776,3.776,3.776-3.776a.89.89,0,1,1,1.259,1.259l-3.776,3.776,3.776,3.776a.89.89,0,1,1-1.259,1.259Z"
                                            transform="translate(-202 -298)" fill="#8479ac" />
                                    </svg>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="group_btn pt-1 justify-content-start">
                    <button mat-button class="btnLight_fill" (click)="addDeatilsItem()">

                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <path id="plus"
                                d="M15.25,9.25h-4.5V4.75a.75.75,0,1,0-1.5,0v4.5H4.75a.75.75,0,1,0,0,1.5h4.5v4.5a.75.75,0,0,0,1.5,0v-4.5h4.5a.75.75,0,0,0,0-1.5Z"
                                transform="translate(-4 -4)" fill="#70639e" />
                        </svg>

                        {{'items-requests.Add Item Details' | translate}}</button>
                </div>


                <div class="inputs-form-section mt-5">

                    <app-file-manager [label]="'Auctions.Item Banner'|translate" [isUploader]="true" [isSubmited]="isSubmitted"
                        (selectedFiles)="MainImage=$event;" (UploadLoading)="LoadingUploadBanner=$event"
                        [allowedExt]="['png','jpg','jpeg']" [MaxFileSize]="5" managerIndex="ItemBanner"
                        [Mode]="'banner'" [maxFiles]="1"
                        [InitialImage]="MainImage?MainImage[0]?.path:''"></app-file-manager>
                </div>



                <div class="inputs-form-section  mt-5">
                    <app-file-manager [label]="'Auctions.Media'|translate" [files]="files" [isUploader]="true" [isSubmited]="isSubmitted"
                        (selectedFiles)="files=$event;" (UploadLoading)="LoadingUploadMedia=$event"
                        [allowedExt]="['png','jpg','jpeg']" [MaxFileSize]="5" managerIndex="MediaImages"
                        [Mode]="'multi'"></app-file-manager>
                </div>


                <div class="group_btn justify-content-between">
                    <button mat-button class="btnLight_fill" matStepperPrevious>{{'items-requests.Back' |
                        translate}}</button>
                    <button mat-button class="btn_fill" type="submit" matStepperNext
                        [disabled]="LoadingUploadBanner||LoadingUploadMedia || !MainImage?.length">{{'items-requests.Next'
                        | translate}}</button>

                </div>
            </form>
        </mat-step>

        <mat-step [stepControl]="Configration_Form">

            <form [formGroup]="Configration_Form">
                <ng-template matStepLabel>{{'items-requests.Bidding Configuration' | translate}}</ng-template>

                <div class="title">{{'Main Auction.Starting bid' | translate}}</div>
                <div class="subtitle">{{'items-requests.Set a fair and reasonable' | translate}}</div>

                <div class="inputs-form-section">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'Main Auction.Starting bid' | translate}}</mat-label>
                        <input appOnlynumber formControlName="minimum_price" matInput maxlength="9">
                        <span matTextSuffix>{{"Main Auction.SR"|translate}}</span>
                        <mat-error *ngIf="hasError(Configration_Form,'minimum_price','required')">
                            {{'Auctions.Field is Required'|translate}}
                        </mat-error>
                    </mat-form-field>
                </div>


                <div class="SlideToggle mt-5">
                    <mat-slide-toggle color="primary" id="slideToggle" formControlName="is_reserve"
                    (change)="reservePrice()"
                        [labelPosition]="'before'">
                        <mat-label for="slideToggle"> {{'items-requests.Set reserve price' | translate}} </mat-label>
                    </mat-slide-toggle>
                    <div class="desc">
                        <p>{{"items-requests.This is the lowest price you're willing to sell the item for" | translate
                            }}.
                        </p>
                        <p>{{'items-requests.In-this-case-even' | translate}}
                        </p>
                        <p>{{'items-requests.The reserve price' | translate}}</p>
                    </div>
                </div>


                <div class="inputs-form-section" [hidden]="!Configration_Form.value.is_reserve">
                    <mat-form-field appearance="outline" class="form-group">
                        <mat-label>{{'Auction Item.Reserveprice' | translate}}</mat-label>
                        <input appOnlynumber formControlName="reserve_price"
                            matInput maxlength="9">
                        <span matTextSuffix>{{"Main Auction.SR"|translate}}</span>
                        <mat-error *ngIf="hasError(Configration_Form,'reserve_price','required')">
                            {{'Auctions.Field is Required'|translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="group_btn justify-content-between">
                    <button mat-button class="btnLight_fill" matStepperPrevious>{{'items-requests.Back' |
                        translate}}</button>
                    <button mat-button class="btn_fill" type="submit" [appLoading]="loading"
                        (click)="onSubmit()">{{data.ButtonText}}</button>
                </div>
            </form>
        </mat-step>

    </mat-stepper>



</mat-dialog-content>

<app-loading *ngIf="loadingData || loadingCategory"></app-loading>